import { useSelector } from 'react-redux';

export default (locationId: string) => {
  return useSelector((state: any) => state.locations?.results?.[locationId]);
};
